import React, { Component } from 'react';
import { HashRouter, Route, Routes, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import * as Loadable from './components/Loadable/Loadable';
import { LiliProvider } from './context/LiliContext';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userInfo: null
    };
  }

  render() {
    const { userInfo } = this.state;
    return (
      <HashRouter>
        <LiliProvider>
          <div className="app">
            <Loadable.Nav userInfo={userInfo} />
            <div className="app-content">
              <Routes>
                <Route exact path="/" element={<Navigate to="/bai-hat" />} />
                <Route exact path="/bai-hat" element={<Loadable.BaiHat />} />
                <Route exact path="/bai-hat/:id" element={<Loadable.BaiHat />} />
                <Route exact path="/about" element={<Loadable.About />} />
                <Route path="*" element={<Loadable.NotFound />} />
              </Routes>
            </div>
          </div>
        </LiliProvider>
        <ToastContainer />
      </HashRouter>
    );
  }
}

export default App;
